import Tooltip from '../Tooltip/Tooltip'
import classes from './PopoutButton.module.scss'
import { forwardRef } from 'react'
import type { ReactNode } from 'react'

export interface Props {
  onClick: () => void
  withTooltips?: boolean
  label: string
  children: ReactNode | ReactNode[]
  size?: 'small' | 'medium'
  withArrow?: boolean
}

const PopoutButton = forwardRef((
  {
    onClick,
    withTooltips = true,
    label,
    children,
    size = 'medium',
    withArrow = false
  }: Props,
  ref: any
) => {
  const buttonSizeClass = size === 'small'
    ? classes.Small
    : ''

  const withArrowClass = withArrow
    ? classes.WithArrow
    : ''

  const styleClass = [
    classes.PopoutButton,
    buttonSizeClass,
    withArrowClass
  ].filter(styleClass => styleClass).join(' ')

  return (
    <button
      aria-label={label} // title is removed as it renders a default tooltip on top of the tooltip in the children
      className={styleClass}
      onClick={onClick}
      ref={ref}
      type='button'
    >
      {
        withTooltips
          ? (
            <Tooltip label={label}>
              {children}
            </Tooltip>
          )
          : children
      }
    </button>
  )
}

)

export default PopoutButton
